import { Svg } from '@hopskipdrive/react-components';

const iconMapper = {
  Passenger: <Svg className="filled" icon="sidebar_riders" />,
  Driver: <Svg className="filled" icon="directions-car-filled" />,
  accountIds: <Svg className="filled" icon="school_building" />,
  riderIds: <Svg className="filled" icon="sidebar_riders" />,
  driverIds: <Svg className="filled" icon="directions-car-filled" />,
};

export const priorityLevelMapper = {
  '0': 'urgent',
  '1': 'high',
  '2': 'medium',
  '3': 'low',
};

export const ValueIcon = ({ value }) => {
  const icon = iconMapper[value];

  if (!icon) {
    return null;
  }

  return icon;
};

export const sortMapper = (direction, field) => {
  const directionString = direction === 'asc' ? 'Ascending' : 'Descending';
  const fieldString = field === 'incident_date' ? 'Incident On' : 'Reported On';

  return fieldString + ', ' + directionString;
};
